import { Injectable, Optional } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EventsService } from './events.service';
import { AppConfig } from '../../app.config';
import { LANGUAGE_WAS_CHANGED } from '../../app.constants';

@Injectable()
export class LanguageService {
  private defaultLang: string;
  private languages = [{
    key: 'en',
    name: 'English',
    shortName: 'En',
    active: false
  }, {
    key: 'de',
    name: 'Deutsch',
    shortName: 'De',
    active: false
  }];

  constructor (
    @Optional() config: AppConfig,
    private translateService: TranslateService,
    private eventBus: EventsService
  ) {
    if (config) {
      this.defaultLang = config.defaultLang;
    }
  }

  activate () {
    this.translateService.setDefaultLang(this.defaultLang);
    this.changeActive(this.defaultLang);
    this.eventBus.on(LANGUAGE_WAS_CHANGED).subscribe(lang => {
      this.changeLanguage(lang);
      this.changeActive(lang);
    })
  }

  changeLanguage (value) {
    this.translateService.use(value);
  }

  changeActive (key) {
    this.languages.forEach(lang => {
      if (lang.key === key) {
        lang.active = true;
      } else {
        lang.active = false;
      }
    });
  }

  getAvailableLanguages () {
    return this.languages;
  }

  getActiveLanguage() {
    let activeLang = '';

    this.languages.forEach(lang => {
        if (lang.active === true) {
            activeLang = lang.key;
        }
    });

    return activeLang;
  }

  translate(key) {
    return this.translateService.instant(key);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/core/services/language.service.ts